import React from 'react';

const AdminDashboardIcon: React.FC<{ className?: string }> = ({ className }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            className={className}
        >
            <rect
                x="3"
                y="3"
                width="7.5"
                height="7.5"
                rx="1.5"
                stroke="currentColor"
                strokeWidth="2"
            />
            <rect
                x="13.5"
                y="3"
                width="7.5"
                height="7.5"
                rx="1.5"
                stroke="currentColor"
                strokeWidth="2"
            />
            <rect
                x="3"
                y="13.5"
                width="7.5"
                height="7.5"
                rx="1.5"
                stroke="currentColor"
                strokeWidth="2"
            />
            <rect
                x="13.5"
                y="13.5"
                width="7.5"
                height="7.5"
                rx="1.5"
                stroke="currentColor"
                strokeWidth="2"
            />
        </svg>
    );
};

export default AdminDashboardIcon;
